getUserAccountValidation